var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 18a3.337 3.337 0 0 1-3.334-3.333V6h-.667a.666.666 0 1 1 0-1.333h2.067A3.339 3.339 0 0 1 9.833 2h1.333a3.34 3.34 0 0 1 3.267 2.667H16.5a.667.667 0 1 1 0 1.333h-.666v8.667A3.338 3.338 0 0 1 12.499 18h-4zm-2.001-3.333a2 2 0 0 0 2 2h4c1.105 0 2-.895 2-2V6h-8v8.667zm1.447-10h5.106a2.003 2.003 0 0 0-1.886-1.333H9.833c-.848 0-1.603.534-1.887 1.333zm3.22 8.667v-4a.667.667 0 1 1 1.333 0v4a.666.666 0 1 1-1.333 0zm-2.666 0v-4a.667.667 0 0 1 1.333 0v4a.666.666 0 0 1-1.333 0z",
    fill: "#737188"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b6cecb36c603c49cefd9daef384ee55c.svg";
export { ForwardRef as ReactComponent };